<app-basic-page [pageTitle]="'Workspace Members'">
  @if (isPremium()) {
    <button
      class="header-right"
      [disabled]="userList().length >= availableMemberCount"
      nz-button
      nzType="primary"
      nzSize="default"
      [matTooltip]="getInviteMembersTooltip()"
      (click)="onInvitePeopleClick()"
    >
      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
      Invite Members
    </button>
  }

  @if (!isPremium()) {
    <app-upgrade-to-premium></app-upgrade-to-premium>
  } @else {
    <div class="basic-card-color blue-background full-width">
      <h3>Members ({{ userList().length }}/{{ availableMemberCount }})</h3>
      <nz-table class="full-width" #membersTable [nzData]="userList()" [nzPaginationType]="'small'" [nzPageSize]="8">
        <thead>
          <tr>
            <th [nzWidth]="'250px'">Email</th>
            <th>Member</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (user of membersTable.data; track $index) {
            <tr>
              <td>
                {{ user.userBoardConfig?.email }}
              </td>
              <td>
                <div class="horizontal">
                  <app-board-icon-title [board]="user"></app-board-icon-title>
                  @if (isCreatorBoard(user)) {
                    <nz-tag [nzColor]="'orange'" [nzBordered]="false">Creator</nz-tag>
                  }
                </div>
              </td>
              <td>
                <div class="horizontal">
                  <!-- <button nz-button nzType="default" nzSize="small" (click)="onDetailsUserBoardClick()">Details</button> -->
                  <button
                    nz-button
                    nzType="text"
                    nzSize="default"
                    [matTooltip]="'Remove from Workspace'"
                    (click)="onRemoveUserBoardClick(user)"
                  >
                    <span nz-icon style="font-size: 24px" class="material-symbols-rounded">delete</span>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>

    <div class="vertical basic-card-color red-background full-width">
      <h3>Pending Member Invites</h3>
      <nz-table
        class="full-width"
        #pendingEmailTable
        [nzData]="pendingEmailList() ?? []"
        [nzPaginationType]="'small'"
        [nzPageSize]="8"
      >
        <thead>
          <tr>
            <th [nzWidth]="'250px'">Email</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (item of pendingEmailTable.data; track $index) {
            <tr>
              <td>
                {{ item.email }}
              </td>
              <td>
                <div class="horizontal">
                  <button nz-button nzType="default" nzSize="small" (click)="onResendEmailClick(item)">
                    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">mail</span>
                    Resend Invite Email
                  </button>
                  <button nz-button nzType="text" nzSize="small" (click)="onRemovePendingEmailClick(item)">
                    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete_forever</span>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>

    <div class="basic-card-color purple-background vertical full-width">
      <h3>Archived Workspace Members</h3>
      <nz-table
        class="full-width"
        #archiedMembersTable
        [nzData]="removedUserList()"
        [nzPaginationType]="'small'"
        [nzPageSize]="8"
      >
        <thead>
          <tr>
            <th [nzWidth]="'250px'">Email</th>
            <th>Member</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (user of archiedMembersTable.data; track $index) {
            <tr>
              <td>
                {{ user.userBoardConfig?.email }}
              </td>
              <td>
                <div class="horizontal">
                  <app-board-icon-title [board]="user"></app-board-icon-title>
                </div>
              </td>
              <td>
                <!-- <button nz-button nzType="default" nzSize="small" (click)="onDetailsUserBoardClick()">Details</button> -->
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  }
</app-basic-page>

<app-invite-team-member-list [(isVisible)]="isInviteTeamMemberVisible"></app-invite-team-member-list>
